import {useNetInfo} from '@react-native-community/netinfo';

export const useIsOffline = () => {
  // isConnected might be null before connection check is settled.
  // This hook guarantees that device is offline and not just checking for the connection check.
  const {isConnected} = useNetInfo();

  return isConnected === false;
};
